
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyB4Z9EBmPXVpjGdZWRDO8G84LqE4jNlPIw",
  authDomain: "francocanalejo-fragnarok.firebaseapp.com",
  databaseURL: "https://francocanalejo-fragnarok-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "francocanalejo-fragnarok",
  storageBucket: "francocanalejo-fragnarok.appspot.com",
  messagingSenderId: "960659338948",
  appId: "1:960659338948:web:fc4a315e58e48a3dc8fb91",
  measurementId: "G-N0Y6G89KWH"
};

const firebaseApp = initializeApp(firebaseConfig);
const analytics = getAnalytics();



export {firebaseApp, analytics}